import React, { ReactNode } from 'react'
import { Header, Image } from 'semantic-ui-react'
import darkLogo from './apex-logo-2020-blue.svg'
import styles from './styles.module.less'

export interface Props {
  title: ReactNode
}

export const AppHeader = ({ title }: Props) => (
  <div className={`${styles.brandedHeader} hide-on-print`}>
    <Image src={darkLogo} alt="Apex Clearing" size="small" />
    <Header as="h5" className={`${styles.appTitle} test-id-app-header-title`}>
      {title}
    </Header>
  </div>
)
